module.exports = __webpack_public_path__ + "static/media/facebook.01ee2134.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook.svg
// module id = 52
// module chunks = 0